import PropTypes from "prop-types"
import React from "react"
import { useTranslation } from "react-i18next"
import DonutChartTemplate from "views/molecules/charts/template/DonutChartTemplate"

const ChartODD13EmissionBreakdownPerRegionMolecule = ({
  score,
  translationScope = "",
}) => {
  const { t } = useTranslation()

  const getTranslationPath = () => {
    if (translationScope === "global") {
      return `score:score.13.chartEmissionBreakdownPerEntity`
    } else {
      return `score:score.13.chartEmissionBreakdownPerRegion`
    }
  }
  return (
    <DonutChartTemplate
      title={t(`${getTranslationPath()}.title`)}
      data={score?.emissions_breakdown?.data}
      labelKeys={score?.emissions_breakdown?.labels}
      centerValue={score?.emissions_breakdown?.doughnut_charts_data_total} // number
      unitPath="units:units.emission"
      unitKey={score?.emissions_breakdown?.unit_key}
      helpText={t(`${getTranslationPath()}.help`)}
    />
  )
}

ChartODD13EmissionBreakdownPerRegionMolecule.propTypes = {
  score: PropTypes.object,
  translationScope: PropTypes.string.isRequired,
}

export default ChartODD13EmissionBreakdownPerRegionMolecule
